(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["viaim-feature-detail"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('viaim-feature-detail')) {
    customElements.define('viaim-feature-detail', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const trigger = this.querySelector('[data-detail-open]');
        const dialog = this.querySelector('dialog');
        if (!trigger || !dialog) return;
        trigger.addEventListener('click', () => {
          dialog.showModal();
          dialog.scrollTop = 0;
          trigger.setAttribute('aria-expanded', 'true');
        }, options);
        this.querySelector('[data-detail-close]').addEventListener('click', () => dialog.close(), options);
        dialog.addEventListener('click', event => {
          const rect = dialog.getBoundingClientRect();
          if (event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) dialog.close();
        }, options);
        dialog.addEventListener('close', () => {
          trigger.setAttribute('aria-expanded', 'false');
          if (trigger.isConnected) trigger.focus({ preventScroll: true });
        }, options);
        if (this.hasAttribute('data-reveal') && !matchMedia('(prefers-reduced-motion: reduce)').matches && 'IntersectionObserver' in window) {
          this.setAttribute('data-pending', '');
          this.observer = new IntersectionObserver(entries => {
            if (entries.some(entry => entry.isIntersecting)) {
              this.removeAttribute('data-pending');
              this.observer.disconnect();
            }
          }, { threshold: .8 });
          this.observer.observe(this);
          trigger.addEventListener('focus', () => this.removeAttribute('data-pending'), options);
        }
      }
      disconnectedCallback() {
        this.querySelector('dialog')?.close();
        this.controller?.abort();
        this.controller = null;
        this.observer?.disconnect();
      }
    });
  }
  if (!customElements.get('viaim-typewriter')) {
    customElements.define('viaim-typewriter', class extends HTMLElement {
      connectedCallback() {
        if (this.started) return;
        this.started = true;
        const text = this.querySelector('.vrd-typewriter__text');
        if (!text || this.dataset.enabled === 'false' || matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
        const full = text.textContent;
        text.textContent = '';
        this.observer = new IntersectionObserver(entries => {
          if (!entries.some(entry => entry.isIntersecting)) return;
          this.observer.disconnect();
          this.setAttribute('data-typing', '');
          const start = performance.now();
          const letters = Array.from(full);
          const tick = now => {
            const count = Math.min(letters.length, Math.floor((now - start) / 32));
            text.textContent = letters.slice(0, count).join('');
            if (count < letters.length) this.frame = requestAnimationFrame(tick);
            else this.removeAttribute('data-typing');
          };
          this.frame = requestAnimationFrame(tick);
        }, { threshold: .5 });
        this.observer.observe(this);
        this.fullText = full;
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        cancelAnimationFrame(this.frame);
        if (this.fullText) this.querySelector('.vrd-typewriter__text').textContent = this.fullText;
        this.removeAttribute('data-typing');
        this.started = false;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["viaim-flexible-media"] && !Shopify.designMode) return;
  try {
    class ViaimAdaptiveMedia extends HTMLElement{
 connectedCallback(){
  this.abort?.abort();this.abort=new AbortController();
  const asset=this.querySelector('img,video');if(!asset||this.dataset.layout==='uniform')return;
  const resize=()=>{const w=asset.naturalWidth||asset.videoWidth,h=asset.naturalHeight||asset.videoHeight;if(w&&h)this.style.setProperty('--natural-ratio',String(w/h))};
  asset.addEventListener(asset.tagName==='IMG'?'load':'loadedmetadata',resize,{signal:this.abort.signal});resize();
 }
 disconnectedCallback(){this.abort?.abort()}
}
if(!customElements.get('viaim-adaptive-media'))customElements.define('viaim-adaptive-media',ViaimAdaptiveMedia);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["viaim-product-design"] && !Shopify.designMode) return;
  try {
    class ProductComfortDetails extends HTMLElement {
 connectedCallback(){
  this.abort?.abort();this.abort=new AbortController();
  const panels=[...this.querySelectorAll('[data-fit]')],art=this.querySelector('.hw-fit-art');
  if(!art)return;
  panels.forEach(panel=>panel.addEventListener('toggle',()=>{
   if(!panel.open)return;
   panels.forEach(other=>{if(other!==panel)other.open=false});
   art.dataset.detail=panel.dataset.fit;
   this.querySelectorAll('[data-fit-media]').forEach(media=>{media.hidden=media.dataset.fitMedia!==panel.dataset.fit;if(media.hidden)media.querySelectorAll('video').forEach(video=>video.pause())});
   const label=art.querySelector('.hw-art-label');if(label)label.textContent=panel.dataset.artLabel;
  },{signal:this.abort.signal}));
 }
 disconnectedCallback(){this.abort?.abort()}
}
if(!customElements.get('product-comfort-details'))customElements.define('product-comfort-details',ProductComfortDetails);


class ProductStoryMedia extends HTMLElement {
 connectedCallback(){
  this.abort?.abort();this.abort=new AbortController();
  const asset=this.querySelector('img,video');
  if(asset&&!this.hasAttribute('data-background')){const resize=()=>{const w=asset.naturalWidth||asset.videoWidth,h=asset.naturalHeight||asset.videoHeight;if(w&&h)this.style.setProperty('--natural-ratio',String(w/h))};asset.addEventListener(asset.tagName==='IMG'?'load':'loadedmetadata',resize,{signal:this.abort.signal});resize()}
  const video=this.querySelector('video'),button=this.querySelector('[data-media-toggle]');
  if(!video||!this.hasAttribute('data-background')||!button)return;
  let userPaused=false;const motion=matchMedia('(prefers-reduced-motion: reduce)');
  const sync=()=>{button.setAttribute('aria-pressed',String(!video.paused));button.setAttribute('aria-label',video.paused?this.dataset.playLabel:this.dataset.pauseLabel);button.firstElementChild.textContent=video.paused?'▶':'Ⅱ'};
  video.addEventListener('play',sync,{signal:this.abort.signal});video.addEventListener('pause',sync,{signal:this.abort.signal});
  button.addEventListener('click',()=>{if(video.paused){userPaused=false;video.play().catch(()=>{})}else{userPaused=true;video.pause()}},{signal:this.abort.signal});
  this.observer=new IntersectionObserver(entries=>{entries.forEach(entry=>{if(entry.isIntersecting&&!motion.matches&&!userPaused){video.play().catch(()=>{})}else{video.pause()}})},{threshold:.1});this.observer.observe(this);sync();
 }
 disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();this.querySelector('video')?.pause()}
}
if(!customElements.get('product-story-media'))customElements.define('product-story-media',ProductStoryMedia);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["viaim-section-motion"] && !Shopify.designMode) return;
  try {
    class ProductStoryMotion extends HTMLElement {
 connectedCallback() {
  this.abort?.abort();this.abort=new AbortController();
  this.seen=new WeakSet();this.running=new Map();
  this.reduced=matchMedia('(prefers-reduced-motion: reduce)');
  this.mobile=matchMedia('(max-width: 760px)');
  this.main=document.getElementById('MainContent');
  if(!this.main||!('IntersectionObserver' in window)||!Element.prototype.animate)return;
  this.selector=[
   '.vpd h2','.vpd .section-head>p','.vpd .hardware-heading>p',
   '.vpd .hw-lifestyle-copy','.vpd .hw-lifestyle-photo','.vpd .hw-detail-head',
   '.vpd .hw-fit-art','.vpd .hw-fit-details','.vpd .hw-sound-art','.vpd .hw-sound-copy',
   '.vpd .hw-power','.vpd .record-steps>article','.vpd .open-plan',
   '.vpd .details-section','.vpd .final-inner','.vpd .hw-highlights',
   '.vrd-hardware__head','.vrd-hardware__photo','.vrd-hardware__features',
   '.vrd-capture__head','.vrd-capture__card',
   '.vrd-workflow-intro__grid','.vrd-workflow-intro__journey',
   '.vrd-capture-step__copy','.vrd-capture-step__stage','.vrd-capture-step__support',
   '.vrd-sense-step__head','.vrd-sense-step__stage','.vrd-sense-step__outputs',
   '.vrd-memory__head','.vrd-memory__card',
   '.vrd-forward-step__head','.vrd-forward-step__visual','.vrd-forward-step__cards',
   '.vrd-trust__wrap','.vcn__card'
  ].join(',');
  this.observer=new IntersectionObserver(entries=>{
   let step=0;
   entries.filter(entry=>entry.isIntersecting).sort((a,b)=>a.boundingClientRect.top-b.boundingClientRect.top).forEach(entry=>{
    const element=entry.target;this.observer.unobserve(element);
    if(this.seen.has(element)||element.closest('[hidden],dialog'))return;
    this.seen.add(element);
    if(entry.boundingClientRect.bottom<0||element.contains(document.activeElement))return;
    const reduce=this.reduced.matches,small=this.mobile.matches;
    const frames=reduce?[{opacity:.85},{opacity:1}]:[
     {opacity:.35,transform:`translateY(${small?12:22}px)`},
     {opacity:1,transform:'translateY(0)'}
    ];
    const animation=element.animate(frames,{
     duration:reduce?180:small?500:650,
     delay:reduce?0:Math.min(step++,3)*50,
     easing:getComputedStyle(this.main).getPropertyValue('--story-ease-out').trim()||'cubic-bezier(0.23,1,0.32,1)',
     fill:'backwards'
    });
    this.running.set(element,animation);
    animation.finished.catch(()=>{}).finally(()=>{if(this.running.get(element)===animation)this.running.delete(element)});
   });
  },{threshold:0,rootMargin:'0px 0px -24px 0px'});
  this.scan(this.main,true);
  document.addEventListener('shopify:section:load',event=>this.scan(event.target,true),{signal:this.abort.signal});
  document.addEventListener('shopify:section:unload',event=>{
   event.target.querySelectorAll(this.selector).forEach(element=>{this.observer.unobserve(element);this.running.get(element)?.cancel()});
  },{signal:this.abort.signal});
  this.main.addEventListener('focusin',event=>{
   this.running.forEach((animation,element)=>{if(element.contains(event.target))animation.cancel()});
  },{signal:this.abort.signal});
  this.reduced.addEventListener('change',()=>{this.running.forEach(animation=>animation.cancel())},{signal:this.abort.signal});
  window.addEventListener('pagehide',()=>{this.running.forEach(animation=>animation.cancel())},{signal:this.abort.signal});
 }
 scan(scope,initial) {
  scope.querySelectorAll(this.selector).forEach(element=>{
   if(this.seen.has(element)||element.closest('[hidden],dialog')||element.parentElement.closest(this.selector))return;
   const rect=element.getBoundingClientRect();
   if(!rect.width||!rect.height)return;
   if(initial&&rect.top<innerHeight){this.seen.add(element);return}
   this.observer.observe(element);
  });
 }
 disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();this.running?.forEach(animation=>animation.cancel())}
}
if(!customElements.get('product-story-motion'))customElements.define('product-story-motion',ProductStoryMotion);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["viaim-workflow-navigation"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',event=>{
 const link=event.target.closest('.vrd-workflow-intro__journey a');if(!link||event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
 const target=document.getElementById(link.hash.slice(1));if(!target)return;event.preventDefault();event.stopPropagation();
 const nav=link.closest('nav');nav.querySelectorAll('a').forEach(item=>item.classList.toggle('is-active',item===link));
 const reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;
 const start=window.scrollY,margin=parseFloat(getComputedStyle(target).scrollMarginTop)||0,end=Math.max(0,Math.min(start+target.getBoundingClientRect().top-margin,document.documentElement.scrollHeight-innerHeight));
 window.viaimWorkflowScroll?.abort();const controller=new AbortController();window.viaimWorkflowScroll=controller;
 const cancel=()=>controller.abort();['wheel','touchstart','pointerdown','keydown'].forEach(type=>window.addEventListener(type,cancel,{once:true,passive:true,signal:controller.signal}));
 const duration=Math.min(1150,Math.max(600,Math.abs(end-start)*.3)),began=performance.now();
 const finish=()=>{history.replaceState(null,'',link.hash);controller.abort()};
 if(reduce){window.scrollTo({top:end,behavior:'instant'});finish();return}
 const tick=now=>{if(controller.signal.aborted)return;const t=Math.min(1,(now-began)/duration),e=t<.5?4*t*t*t:1-Math.pow(-2*t+2,3)/2;window.scrollTo({top:start+(end-start)*e,behavior:'instant'});if(t<1)requestAnimationFrame(tick);else finish()};requestAnimationFrame(tick);
},true);
  } catch(e) { console.error(e); }
})();

})();
